import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
// import 'react-app-polyfill/stable';
import React from "react";
import ReactDOM from "react-dom";
import { MatomoProvider, createInstance } from "@datapunt/matomo-tracker-react";
import App from "./App";
import * as serviceWorker from "./serviceWorker";

const matomoInstance = createInstance({
    urlBase: "https://stats.stat.gov.pl",
    siteId:
        process?.env?.REACT_APP_MATOMO_IDSITE && !isNaN(Number(process?.env?.REACT_APP_MATOMO_IDSITE))
            ? Number(process?.env?.REACT_APP_MATOMO_IDSITE)
            : 5,
    // disabled: false,
    //disabled: window.location.hostname === "localhost",
    heartBeat: {
        active: true,
        seconds: 10,
    },
    linkTracking: false,
    configurations: {
        disableCookies: true,
        // disableCookies: false,
        setSecureCookie: true,
        setRequestMethod: "POST",
    },
});

if (process.env.NODE_ENV === "production") {
    console.assert = () => {};
    console.count = () => {};
    console.debug = () => {};
    console.dir = () => {};
    console.dirxml = () => {};
    console.error = () => {};
    console.info = () => {};
    console.log = () => {};
    console.table = () => {};
    console.trace = () => {};
    console.warn = () => {};
}

ReactDOM.render(
    <React.Fragment>
        <MatomoProvider value={matomoInstance}>
            <App />
        </MatomoProvider>
    </React.Fragment>,
    document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
